export default __webpack_public_path__ + "static/media/excelicon.9c8b7d8b.png";